import axios from 'axios';
import {Slide, Link} from './types'

const API_URL = 'https://stage.selfdetailing.ru/api';

// Создаем экземпляр axios с базовой конфигурацией
const api = axios.create({
    baseURL: API_URL,
});

interface UserProfile {
    id: number;
    role: string;
    name: string;
    status: string;
    login: string;
    createdAt: string;
}

// Добавляем интерсептор для добавления токена в заголовки запросов
api.interceptors.request.use(
    async (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue: any[] = [];

const processQueue = (error: any, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    failedQueue = [];
};
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response.status === 401 && !originalRequest._retry) {
            // console.log(error.response.data.detail)
            if (error.response.data.detail === "Invalid refresh token"){
                logoutUser();
            }
            if (isRefreshing) {
                return new Promise((resolve, reject) => {
                    failedQueue.push({resolve, reject});
                }).then(token => {
                    originalRequest.headers['Authorization'] = 'Bearer ' + token;
                    return api(originalRequest);
                }).catch(err => {
                    return Promise.reject(err);
                });
            }

            originalRequest._retry = true;
            isRefreshing = true;

            return new Promise((resolve, reject) => {
                const refresh_token = localStorage.getItem('refresh_token');
                api.post('/oauth/refresh', { refresh_token })
                    .then(response => {
                        const newToken = response.data.access_token;
                        localStorage.setItem('access_token', newToken);
                        localStorage.setItem('refresh_token', response.data.refresh_token);
                        api.defaults.headers.common['Authorization'] = 'Bearer ' + newToken;
                        originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
                        processQueue(null, newToken);
                        resolve(api(originalRequest));
                    })
                    .catch(err => {
                        processQueue(err, null);
                        logoutUser();
                        reject(err);
                    })
                    .finally(() => {
                        isRefreshing = false;
                    });
            });
        }
        return Promise.reject(error);
    }
);

const logoutUser = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    window.location.href = '/login';
};

// Функция для авторизации и получения токена
export const login = async (email: string, password: string) => {
    try {
        const response = await api.post('/api/v1/auth/signin', {email, password});
        localStorage.setItem('access_token', response.data.meta.accessToken);
        localStorage.setItem('refresh_token', response.data.meta.refreshToken);
        return response.data;
    } catch (error) {
        console.error('Login error:', error);
        throw error; // Проброс ошибки для обработки в компоненте
    }
};
export const fetchUserData = async () => {
    const response = await api.get(`/v1/user/me`);
    return response.data;
};

export const fetchProducts = async (page: number, limit: number = 100) => {
    try {
        const response = await api.get('/product', {
            params: { page, limit }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching products:', error);
        throw error;
    }
};


export const addProduct = async (data: { title: string; description: string; pictureId: number; }) => {
    const response = await api.post('/product', data);
    return response.data;
};
export const updateProduct = async (productId: number | undefined, data: { pictureId: number; description: string | undefined; title: string | undefined }) => {
    const response = await api.patch(`/product/${productId}`, data);
    return response.data;
};
export const deleteProduct = async (id: number | undefined) => {
    const response = await api.delete(`/product/${id}`);
    return response.data;
};


export const fetchCustomFieldDef = async (page: number, limit: number = 100) => {
    try {
        const response = await api.get('/custom-field-definition', {
            params: { page, limit }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching products:', error);
        throw error;
    }
};
export const addCustomFieldDefinition = async (data: { entity: string; title: string; description: string; required: boolean; }) => {
    const response = await api.post('/custom-field-definition', data);
    return response.data;
};
export const updateCustomFieldDefinition = async (id: number | undefined, data: { entity: string | undefined; title: string | undefined; description: string | undefined; required: boolean | undefined; }) => {
    const response = await api.patch(`/custom-field-definition/${id}`, data);
    return response.data;
};
export const deleteCustomFieldDefinition = async (id: number | undefined) => {
    const response = await api.delete(`/custom-field-definition/${id}`);
    return response.data;
};

export const uploadPhoto = async (file: File, onProgress: (progress: number) => void) => {
    const formData = new FormData();
    formData.append('file', file);
    try {
        const response = await api.post('/picture/upload', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (progressEvent) => {
                if (progressEvent.total) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onProgress(percentCompleted);
                }
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading video:', error);
        throw error;
    }
};



//
// // Функция для авторизации и получения токена
// export const forgot = async (email: string) => {
//     try {
//         const response = await api.post('/password_reset/request', {email});
//         return response.data;
//     } catch (error) {
//         console.error('Login error:', error);
//         throw error; // Проброс ошибки для обработки в компоненте
//     }
// };
//
// // Функция для регистрации
// export const register = async (email: string, password: string) => {
//     try {
//         const response = await api.post('/users/', {email, password});
//         return response.data;
//     } catch (error) {
//         console.error('Registration error:', error);
//         throw error;
//     }
// };
//
// // Функция для подтверждения email
// export const confirmEmailPath = async (token: string) => {
//     try {
//         const response = await api.get('/users/confirm-email', {
//             params: {token},
//         });
//         return response.data;
//     } catch (error) {
//         console.error('Email confirmation error:', error);
//         throw error;
//     }
// };
//
// export const resetPassword = async (email: string, otp: string, newPassword: string) => {
//     const response = await api.post('/password_reset/confirm', { email, otp, new_password: newPassword });
//     return response.data;
// };
//
// export const getUserPermissions = async (userId: string) => {
//     const response = await api.get(`/users/get_permissions/${userId}`);
//     return response.data;
// };

// // Функция для проверки аутентификации
// export const isAuthenticated = () => {
//     return !!localStorage.getItem('access_token');
// };

// // Функция для выхода из системы
// export const logout = () => {
//     localStorage.removeItem('access_token');
// };
export const addPresentation = async (data: { title: string; description: string; pictureId: number; }) => {
    const response = await api.post('/presentation', data);
    return response.data;
};

export const fetchPresentations = async (page: number, limit: number) => {
    try {
        const response = await api.get('/presentation', { params: { page, limit } });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error('Error fetching projects:', error.response?.data || error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        throw error; // Rethrow the error after logging
    }
};
export const fetchPresentation = async (presentationId: string | undefined) => {
    const response = await api.get(`/presentation/${presentationId}`);
    return response.data;
};
export const updatePresentation = async (presentationId: number | undefined, data: { pictureId: number; description: string | undefined; title: string | undefined }) => {
    const response = await api.patch(`/presentation/${presentationId}`, data);
    return response.data;
};

export const uploadPresentationArchive = async (presentationId: number | undefined, file: File, onProgress: (progress: number) => void) => {
    const formData = new FormData();
    formData.append('file', file);
    try {
        const response = await api.post(`/presentation/upload-archive/${presentationId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (progressEvent) => {
                if (progressEvent.total) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onProgress(percentCompleted);
                }
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading image:', error);
        throw error;
    }
};
export const deleteSlideFromPresentation = async (id: number | undefined) => {
    const response = await api.delete(`/slide/${id}`);
    return response.data;
};



// export const fetchProjectChanges = async (projectId: string | null, page: number) => {
//     try {
//         const response = await api.get(`/projects/${projectId}/changes`, {
//             params: { page },
//             headers: {
//                 Authorization: `Bearer ${localStorage.getItem('token')}`,
//             },
//         });
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching project changes:', error);
//         throw error;
//     }
// };
//
// export const deleteProject = async (id: string) => {
//     const response = await api.delete(`/projects/${id}`);
//     return response.data;
// };
//
// export const getProject = async (id: string) => {
//     const response = await api.get(`/projects/${id}`);
//     return response.data;
// };
//
// export const uploadProjectImage = async (projectId: string, file: File, onProgress: (progress: number) => void) => {
//     const formData = new FormData();
//     formData.append('file', file);
//     try {
//         const response = await api.post(`/projects/${projectId}/upload-image`, formData, {
//             headers: {
//                 'Content-Type': 'multipart/form-data',
//             },
//             onUploadProgress: (progressEvent) => {
//                 if (progressEvent.total) {
//                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                     onProgress(percentCompleted);
//                 }
//             },
//         });
//         return response.data;
//     } catch (error) {
//         console.error('Error uploading image:', error);
//         throw error;
//     }
// };
//

// export const getUserProfile = async () => {
//     const response = await api.get('/users/me/');
//     return response.data;
// };
//
// export const updateProfile = async (profile: UserProfile) => {
//     const response = await api.put(`/users/${profile.id}`, profile);
//     return response.data;
// };

// export const changePassword = async (old_password: string, new_password: string) => {
//     const response = await api.post('/users/change_password', { old_password, new_password });
//     return response.data;
// };
//
// export const uploadUserAvatar = async (userId: string, file: File) => {
//     const formData = new FormData();
//     formData.append('file', file);
//     try {
//         const response = await api.post(`/users/${userId}/upload-image`, formData, {
//             headers: {
//                 'Content-Type': 'multipart/form-data',
//             },
//         });
//         return response.data;
//     } catch (error) {
//         console.error('Error uploading avatar:', error);
//         throw error;
//     }
// };
//
// export const fetchCompanyMembers = async (page: number, limit: number) => {
//     const response = await api.get('/users/company-users/', { params: { page, limit } });
//     return response.data;
// };
//
// export const addCompanyMember = async (email: string) => {
//     const response = await api.post(`/users/add_to_team?email=${ email }`, {  });
//     return response.data;
// };
//
// export const updateCompanyMember = async (userId: string, data: { is_active: boolean }) => {
//     const response = await api.put(`/users/${userId}`, data);
//     return response.data;
// };
//
// export const deleteCompanyMember = async (userId: string) => {
//     const response = await api.delete(`/users/${userId}`);
//     return response.data;
// };
//
// export const fetchUserPermissions = async (userId: string): Promise<Permissions> => {
//     try {
//         const response = await api.get(`/users/get_permissions/${userId}`);
//         // console.log(response.data)
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching user permissions:', error);
//         throw error;
//     }
// };
//
// export const setUserPermissions = async (userId: string, permissions: Permissions) => {
//     const response = await api.put(`/users/update_permissions/${userId}`, {...permissions });
//     return response.data;
// };
//
//
// export const createVideoFolder = async (folderName: string) => {
//     try {
//         const response = await api.post('/videos/folders/', { name: folderName });
//         return response.data;
//     } catch (error) {
//         console.error('Error creating folder:', error);
//         throw error;
//     }
// };
//
// export const getVideoFolders = async () => {
//     try {
//         const response = await api.get('/videos/folders/');
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching folders:', error);
//         throw error;
//     }
// };
//
// export const getVideos = async (params: { page?: number; limit?: number; folder_id?: string | null; sortBy?: string }) => {
//     try {
//         const response = await api.get('/videos/', { params });
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching videos:', error);
//         throw error;
//     }
// };
//
// export const uploadVideo = async (file: File, folderId: string | null, onProgress: (progress: number) => void) => {
//     const formData = new FormData();
//     formData.append('file', file);
//     if (folderId) {
//         formData.append('folder_id', folderId);
//     }
//     try {
//         const response = await api.post('/videos/upload', formData, {
//             headers: { 'Content-Type': 'multipart/form-data' },
//             onUploadProgress: (progressEvent) => {
//                 if (progressEvent.total) {
//                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                     onProgress(percentCompleted);
//                 }
//             },
//         });
//         return response.data;
//     } catch (error) {
//         console.error('Error uploading video:', error);
//         throw error;
//     }
// };
//
// export const uploadVideoWEBM = async (file: File, folderId: string | null, slideId: string | null, onProgress: (progress: number) => void) => {
//     const formData = new FormData();
//     formData.append('file', file);
//     if (folderId) {
//         formData.append('folder_id', folderId);
//     }
//     if (slideId) {
//         formData.append('slide_id', slideId);
//     }
//     try {
//         const response = await api.post('/videos/uploadwebm', formData, {
//             headers: { 'Content-Type': 'multipart/form-data' },
//             onUploadProgress: (progressEvent) => {
//                 if (progressEvent.total) {
//                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                     onProgress(percentCompleted);
//                 }
//             },
//         });
//         return response.data;
//     } catch (error) {
//         console.error('Error uploading video:', error);
//         throw error;
//     }
// };

// export const deleteVideoFolder = async (folderId: string) => {
//     try {
//         const response = await api.delete(`/videos/folders/${folderId}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error deleting folder:', error);
//         throw error;
//     }
// };
//
// export const deleteVideo = async (videoId: string) => {
//     try {
//         const response = await api.delete(`/videos/${videoId}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error deleting video:', error);
//         throw error;
//     }
// };
//
//
//
// export const createAudioFolder = async (folderName: string) => {
//     try {
//         const response = await api.post('/audios/folders/', { name: folderName });
//         return response.data;
//     } catch (error) {
//         console.error('Error creating folder:', error);
//         throw error;
//     }
// };
//
// export const getAudioFolders = async () => {
//     try {
//         const response = await api.get('/audios/folders/');
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching folders:', error);
//         throw error;
//     }
// };
//
// export const getAudios = async (params: { page?: number; limit?: number; folder_id?: string | null; slide_id?: string | null; sortBy?: string }) => {
//     try {
//         const response = await api.get('/audios/', { params });
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching audios:', error);
//         throw error;
//     }
// };
//
// export const uploadAudio = async (file: File, folderId: string | null, slideId: string | null, onProgress: (progress: number) => void) => {
//     const formData = new FormData();
//     formData.append('file', file);
//     formData.append('time', '0');
//     if (folderId) {
//         formData.append('folder_id', folderId);
//     }
//     if (slideId) {
//         formData.append('slide_id', slideId);
//     }
//     try {
//         const response = await api.post('/audios/upload', formData, {
//             headers: { 'Content-Type': 'multipart/form-data' },
//             onUploadProgress: (progressEvent) => {
//                 if (progressEvent.total) {
//                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                     onProgress(percentCompleted);
//                 }
//             },
//         });
//         return response.data;
//     } catch (error) {
//         console.error('Error uploading audio:', error);
//         throw error;
//     }
// };
//
// export const deleteAudioFolder = async (folderId: string) => {
//     try {
//         const response = await api.delete(`/audios/folders/${folderId}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error deleting folder:', error);
//         throw error;
//     }
// };
//
// export const deleteAudio = async (audioId: string) => {
//     try {
//         const response = await api.delete(`/audios/${audioId}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error deleting audio:', error);
//         throw error;
//     }
// };
// export const updateAudioTime = async (id: string, time: number) => {
//     try {
//         const response = await api.put(`/audios/${id}`,{ time });
//         return response.data;
//     } catch (error) {
//         console.error('Error deleting audio:', error);
//         throw error;
//     }
// };
//
//
//
// export const createPDFFolder = async (folderName: string) => {
//     try {
//         const response = await api.post('/pdfs/folders/', { name: folderName });
//         return response.data;
//     } catch (error) {
//         console.error('Error creating folder:', error);
//         throw error;
//     }
// };
//
// export const getPDFFolders = async () => {
//     try {
//         const response = await api.get('/pdfs/folders/');
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching folders:', error);
//         throw error;
//     }
// };
//
// export const getPDFs = async (params: { page?: number; limit?: number; folder_id?: string | null; sortBy?: string }) => {
//     try {
//         const response = await api.get('/pdfs/', { params });
//         return response.data;
//     } catch (error) {
//         console.error('Error fetching pdfs:', error);
//         throw error;
//     }
// };
//
// export const uploadPDF = async (file: File, folderId: string | null, onProgress: (progress: number) => void) => {
//     const formData = new FormData();
//     formData.append('file', file);
//     if (folderId) {
//         formData.append('folder_id', folderId);
//     }
//     try {
//         const response = await api.post('/pdfs/upload', formData, {
//             headers: { 'Content-Type': 'multipart/form-data' },
//             onUploadProgress: (progressEvent) => {
//                 if (progressEvent.total) {
//                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                     onProgress(percentCompleted);
//                 }
//             },
//         });
//         return response.data;
//     } catch (error) {
//         console.error('Error uploading pdf:', error);
//         throw error;
//     }
// };
//
// export const deletePDFFolder = async (folderId: string) => {
//     try {
//         const response = await api.delete(`/pdfs/folders/${folderId}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error deleting folder:', error);
//         throw error;
//     }
// };
//
// export const deletePDF = async (pdfId: string) => {
//     try {
//         const response = await api.delete(`/pdfs/${pdfId}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error deleting pdf:', error);
//         throw error;
//     }
// };
//

//
// export const uploadPresentation = async (projectId: string, file: File, onProgress: (progress: number) => void) => {
//     const formData = new FormData();
//     formData.append('file', file);
//     const response = await api.post(`/projects/${projectId}/upload-presentation`, formData, {
//         headers: { 'Content-Type': 'multipart/form-data' },
//         onUploadProgress: (progressEvent) => {
//             if (progressEvent.total) {
//                 const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
//                 onProgress(percentCompleted);
//             }
//         },
//     });
//     return response.data;
// };
//
// export const getSlides = async (projectId: string) => {
//     const response = await api.get('/slides/', { params: { project_id: projectId, page: 1, limit: 1000 } });
//     return response.data;
// };
//
// export const getChapters = async (projectId: string) => {
//     const response = await api.get('/chapters/', { params: { project_id: projectId } });
//     return response.data;
// };
//
// export const addChapter = async (data: { name: string; project_id: string; sort: number; external_id?: string }) => {
//     const response = await api.post('/chapters/', data);
//     return response.data;
// };
//
// export const getChapterSlides = async (chapterId: string) => {
//     const response = await api.get(`/chapter-slides/${chapterId}`);
//     return response.data;
// };

export const addCustomField = async (data: { presentationId: number | undefined; value: string; definitionId: any }) => {
    const response = await api.post('/custom-field/', data);
    return response.data;
};
export const getSlide = async (slideId: number | null) => {
    const response = await api.get(`/slide/${slideId}`);
    return response.data;
};
export const updateSlide = async (slideId: number | undefined, data: { description: string | undefined; title: string | undefined; durationMs: number }) => {
    const response = await api.patch(`/slide/${slideId}`, data);
    return response.data;
};
export const updateCustomField = async (customFieldId: number | undefined, data: { value: string | undefined; }) => {
    const response = await api.patch(`/custom-field/${customFieldId}`, data);
    return response.data;
};
export const getStatisticsByVisit = async () => {
    const response = await api.get(`/statistic/by-visit`);
    return response.data;
};
export const getStatisticsBySlide = async (doctorId: string | undefined, visitId: number | undefined) => {
    const response = await api.get(`/statistic/by-slide?doctorId=${doctorId}&visitId=${visitId}`);
    return response.data;
};


export const getNewStatistics = async (date_from: string | null, date_to: string | null, device: string | null, doctor_id: string | null, project_id: string | null, slide: string | null, page: number, page_size: number) => {
    const response = await api.get('https://stat.selfdetailing.ru/statistics/', { params: { date_from: date_from, date_to: date_to, device: device, doctor_id: doctor_id, project_id: project_id, slide: slide, page: page, page_size: page_size } });
    return response.data;
};

export const getNewProjStatistics = async (date_from: string | null, date_to: string | null, doctor_id: string | null, project: string | null, page: number, page_size: number) => {
    const response = await api.get('https://stat.selfdetailing.ru/statistics/by_project', { params: { date_from: date_from, date_to: date_to, doctor_id: doctor_id, project: project, page: page, page_size: page_size } });
    return response.data;
};

// export const addSlideToChapter = async (chapterId: string, slideId: string) => {
//     try {
//         const response = await api.post(`/chapter-slides/${chapterId}`, [slideId]);
//         return response.data;
//     } catch (error) {
//         console.error('Error adding slide to chapter:', error);
//         throw error;
//     }
// };
// export const addSlidesToChapter = async (chapterId: string, slideIds: string[]) => {
//     try {
//         const response = await api.post(`/chapter-slides/${chapterId}`, slideIds);
//         return response.data;
//     } catch (error) {
//         console.error('Error adding slide to chapter:', error);
//         throw error;
//     }
// };
//
// export const reorderChapterSlides = async (chapterId: string, newOrder: string[]) => {
//     try {
//         const response = await api.put(`/chapter-slides/${chapterId}/reorder`, newOrder);
//         return response.data;
//     } catch (error) {
//         console.error('Error reordering slides:', error);
//         throw error;
//     }
// };
//
// export const deleteChapterSlide = async (chapterSlideId: string) => {
//     try {
//         const response = await api.delete(`/chapter-slides/${chapterSlideId}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error deleting chapter slide:', error);
//         throw error;
//     }
// };
//
// export const updateSlide = async (slideId: string, data: Partial<Slide>) => {
//     const response = await api.put(`/slides/${slideId}`, data);
//     return response.data;
// };
// export const refreshSlide = async (slideId: string) => {
//     const response = await api.put(`/slides/${slideId}/refresh_html`);
//     return response.data;
// };
// export const updateSlideHtml = async (slideId: string, data: Partial<Slide>) => {
//     const response = await api.put(`/slides/${slideId}/html`, data);
//     return response.data;
// };
// export const deleteSlide = async (slideId: string) => {
//     const response = await api.delete(`/slides/${slideId}`);
//     return response.data;
// };
//
// export const createLink = async (linkData: {
//     name: string;
//     link_type: string;
//     url: string;
//     slide_id: string | undefined;
// }) => {
//     const response = await api.post('/links/', linkData);
//     return response.data;
// };
// export const getLink = async (linkId: string) => {
//     const response = await api.get(`/links/${linkId}`);
//     return response.data;
// };
// export const getLinkSlides = async (linkId: string) => {
//     const response = await api.get(`/link-slides/${linkId}`);
//     return response.data;
// };
// export const updateLink = async (linkId: string, data: Partial<Link>) => {
//     const response = await api.put(`/links/${linkId}`, data);
//     return response.data;
// };
// export const addSlideToLink = async (linkId: string, slideIds: string[]) => {
//     try {
//         const response = await api.post(`/link-slides/${linkId}`, slideIds);
//         return response.data;
//     } catch (error) {
//         console.error('Error adding slide to chapter:', error);
//         throw error;
//     }
// };
// export const deleteLinkSlide = async (linkId: string, linkSlideId: string) => {
//     try {
//         const response = await api.delete(`/link-slides/${linkId}/${linkSlideId}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error deleting chapter slide:', error);
//         throw error;
//     }
// };
//
// export const processProject = async (project_id: string) => {
//     const response = await api.post(`/projects/${project_id}/process`, {});
//     return response.data;
// };

export const getScenarios = async (page?: number, limit?: number) => {
    try {
        const response = await api.get('/scenario/', {
            params: { page, limit }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching audios:', error);
        throw error;
    }
};
export const addScaenario = async (data: { title: string; description: string; pictureId: number; }) => {
    const response = await api.post('/scenario/', data);
    return response.data;
};
export const fetchScenario = async (scenario_id: number) => {
    const response = await api.get(`/scenario/${scenario_id}`);
    return response.data;
};
export const updateScenario = async (scenarioId: number | undefined, data: { pictureId: number; description: string | undefined; title: string | undefined, visitesIds: number[] }) => {
    const response = await api.patch(`/scenario/${scenarioId}`, data);
    return response.data;
};
export const getVisits = async (scenarioId?: number) => {
    try {
        const response = await api.get(`/visit?scenarioId=${scenarioId}`, {});
        return response.data;
    } catch (error) {
        console.error('Error fetching audios:', error);
        throw error;
    }
};
export const fetchVisit = async (visit_id: number) => {
    const response = await api.get(`/visit/${visit_id}`);
    return response.data;
};

export const addVisit = async (data: { title: string; description: string; pictureId: number; }) => {
    const response = await api.post('/visit/', data);
    return response.data;
};
export const deleteVisit = async (id: number | undefined) => {
    const response = await api.delete(`/visit/${id}`);
    return response.data;
};
export const updateVisit = async (visitId: number | undefined, data: { pictureId: number; description: string | undefined; title: string | undefined, slidesIds: number[] }) => {
    const response = await api.patch(`/visit/${visitId}`, data);
    return response.data;
};
export const generateVisitVideo = async (id: number | undefined) => {
    const response = await api.patch(`/visit/generate-video/${id}`);
    return response.data;
};

// export const addVisit = async (data: { name: string; scenario_id: string; sort: number; external_id?: string }) => {
//     const response = await api.post('/visits/', data);
//     return response.data;
// };
// export const addSlideToVisit = async (visitId: string, slideId: string) => {
//     try {
//         const response = await api.post(`/visit-slides/${visitId}`, [slideId]);
//         return response.data;
//     } catch (error) {
//         console.error('Error adding slide to visit:', error);
//         throw error;
//     }
// };
// export const getVisits = async (scenarioId: string, page: number, limit: number) => {
//     const response = await api.get('/visits/', { params: { scenario_id: scenarioId, page: page, limit: limit } });
//     return response.data;
// };
// export const getVisitSlides = async (visit_id: string) => {
//     const response = await api.get('/visit-slides/', { params: { visit_id: visit_id } });
//     return response.data;
// };
// export const deleteVisit = async (visitId: string) => {
//     try {
//         const response = await api.delete(`/visits/${visitId}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error deleting visit slide:', error);
//         throw error;
//     }
// };
// export const reorderVisitSlides = async (visitId: string, newOrder: string[]) => {
//     try {
//         const response = await api.put(`/visit-slides/${visitId}/reorder`, newOrder);
//         return response.data;
//     } catch (error) {
//         console.error('Error reordering slides:', error);
//         throw error;
//     }
// };
//
// export const deleteVisitSlide = async (visitSlideId: string) => {
//     try {
//         const response = await api.delete(`/visit-slides/${visitSlideId}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error deleting visit slide:', error);
//         throw error;
//     }
// };

// export const addSlideToHot = async (data: { slide_id: string; parent_id: string }) => {
//     const response = await api.post('/hot-slides/', data);
//     return response.data;
// };
// export const duplicateHotSlide = async (project_id: string, slide_id: string) => {
//     const response = await api.post(`/hot-slides/apply-to-all/${project_id}/${slide_id}`, {});
//     return response.data;
// };
// export const getHotSlides = async (parent_id: string) => {
//     const response = await api.get(`/hot-slides/parent/${parent_id}`, { params: {  } });
//     return response.data;
// };
// export const reorderHotSlides = async (parent_id: string, newOrder: string[]) => {
//     try {
//         const response = await api.put(`/hot-slides/${parent_id}/reorder`, newOrder);
//         return response.data;
//     } catch (error) {
//         console.error('Error reordering slides:', error);
//         throw error;
//     }
// };
//
// export const deleteHotSlide = async (hot_slide_id: string) => {
//     try {
//         const response = await api.delete(`/hot-slides/${hot_slide_id}`);
//         return response.data;
//     } catch (error) {
//         console.error('Error deleting chapter slide:', error);
//         throw error;
//     }
// };
// export const editVisitName = async (visitId: string, visitName: string) => {
//     try {
//         const response = await api.patch(`/visits/${visitId}/rename?name=${visitName}`, { });
//         return response.data;
//     } catch (error) {
//         console.error('Error reordering slides:', error);
//         throw error;
//     }
// };

export const addProject = async (data: any) => {
    const response = await api.post('/project/', data);
    return response.data;
};
export const fetchProjects = async (page: number, limit: number, status: string | null, startDateGt: string | null, startDateLte: string | null, endDateGt: string | null, endDateLte: string | null) => {
    try {
        const response = await api.get('/project', { params: { page, limit, status, startDateGt, startDateLte, endDateGt, endDateLte} });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            console.error('Error fetching projects:', error.response?.data || error.message);
        } else {
            console.error('Unexpected error:', error);
        }
        throw error; // Rethrow the error after logging
    }
};
export const fetchProject = async (projectId: number) => {
    const response = await api.get(`/project/${projectId}`);
    return response.data;
};

export const uploadProjectVideo = async (projectId: number | undefined, file: File, onProgress: (progress: number) => void) => {
    const formData = new FormData();
    formData.append('file', file);
    try {
        const response = await api.post(`/project/upload-video/${projectId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (progressEvent) => {
                if (progressEvent.total) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onProgress(percentCompleted);
                }
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading image:', error);
        throw error;
    }
};

export const updateProject = async (projectId: number | undefined, data: any) => {
    const response = await api.patch(`/project/${projectId}`, data);
    return response.data;
};


export default api;
